import PacienteService from "@/services/PacienteService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const paciente = {
    namespace:true,
    state: {pacientes:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListPaciente({commit},pageNumber){
            return await PacienteService.getlist(pageNumber).then(
                response=>{    
                    commit('setPacientes',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListPaciente({commit},search){          
            return await PacienteService.getSearch(search).then (
                response =>{                    
                    commit('setPacientes',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setPacientes(state,data){
        state.pacientes = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.pacientes.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};